var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._t("cell-readonly",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.$options.cellValue(_vm.props.cell, _vm.props.row))+" ")])]},{"currentValue":_vm.$options.cellValue(_vm.props.cell, _vm.props.row),"column":_vm.props.cell,"row":_vm.props.row})],2)}
var staticRenderFns = []

export { render, staticRenderFns }